export enum PaginationType {
    lines = "lines",
    dots = "dots"
}